import { render, staticRenderFns } from "./openScreenAd.vue?vue&type=template&id=50590bf8&scoped=true"
import script from "./openScreenAd.vue?vue&type=script&lang=js"
export * from "./openScreenAd.vue?vue&type=script&lang=js"
import style0 from "./openScreenAd.vue?vue&type=style&index=0&id=50590bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50590bf8",
  null
  
)

export default component.exports